import React from 'react'
import {
  CardList,
  CardGrid,
  CardCarousel,
  CardCollection,
  CardImageOnly,
  CardPerson,
} from './src/index'
import { CardCollectionsProps } from './CardCollectionsProps.types'
import { CardCollectionsTemplateProps } from './CardCollectionsTemplateProps.types'

export const CardCollections = (props: CardCollectionsProps) => {
  const { template } = props.content
  switch (template) {
    case CardCollectionsTemplateProps.Card_List:
    case CardCollectionsTemplateProps.Card_List_nextGen:
      return <CardList {...props.content} />
    case CardCollectionsTemplateProps.Card_Carousel:
    case CardCollectionsTemplateProps.Card_Carousel_nextGen:
      return <CardCarousel {...props.content} />
    case CardCollectionsTemplateProps.Card_Background:
    case CardCollectionsTemplateProps.Card_Footer:
      return <CardCollection {...props.content} />
    case CardCollectionsTemplateProps.Card_Image_Only:
      return <CardImageOnly {...props.content} />
    case CardCollectionsTemplateProps.Card_Person:
      return <CardPerson {...props.content} />
    default:
      return <CardGrid {...props.content} />
  }
}
